import { getAlertMessage } from '../constants/alertMessages';
import { AlertPosition, AlertType } from '../enum/EnumRepository';
import { useStandardAlertStore } from '../store/portal/alertStore';

export const isUnsupportedImageFile = (file: Pick<File, 'name' | 'type'>): boolean => (
  /\.(heic|avif|tif|tiff)$/i.test(file.name) ||
  /^image\/(heic|heic-sequence|avif|avif-sequence|tiff)$/i.test(file.type)
);

export const filterUnsupportedImageFiles = (files: File[]): File[] => {
  const supported = files.filter((file) => !isUnsupportedImageFile(file));
  if (supported.length !== files.length) {
    useStandardAlertStore.getState().enqueueAlert({
      type: AlertType.ALERT,
      position: AlertPosition.TOP,
      content: getAlertMessage('UNSUPPORTED_IMAGE_UPLOAD_FORMAT'),
    });
  }
  return supported;
};

export const filterSupportedImageFiles = (files: File[]): File[] => (
  filterUnsupportedImageFiles(files).filter((file) => file.type.startsWith('image/'))
);
